export class Util {
  public setSecureStorage(sKey: string, oValue: any) {
    oValue = this.stringjson(oValue);
    window.localStorage.setItem(sKey, oValue);
  }

  public getSecureStorage(sKey: string): any {
    let data = window.localStorage.getItem(sKey);
    data = this.parsejson(data);

    return data;

  }

  public removeSecureStorage(sKey: string) {
    window.localStorage.removeItem(sKey);
  }

  private stringjson(vValue) {
    const value = vValue !== undefined && vValue !== null ? JSON.stringify(vValue) : "";
    return value;
  }

  private parsejson(vValue) {
    let retValue;
    if (vValue !== undefined && vValue?.slice(0, 1) !== "0" && vValue !== "") {
      retValue = JSON.parse(vValue);
    } else {
      retValue = vValue;
    }

    return retValue;
  }

  public numberFormat(value: any, options: object) {
    const defaultOptions = {
      toNumber_digits: undefined,
      toNumber_default: 0
    };
    for (const key in options) {
      if (options.hasOwnProperty(key)) { defaultOptions["toNumber_" + key] = options[key]; }
    }
    const defaultNum = defaultOptions.toNumber_default;
    if (value === undefined || value === "") { return defaultNum; }
    if (value.constructor !== String && value.constructor !== Number) {
    }
    let num;
    switch (value.constructor) {
      case Number:
        num = value;
        break;
      case String:
        let sign = "";
        let decimal = "";
        const numSplit = value.split(".");
        if (numSplit.length === 2) {
          num = numSplit[0];
          decimal = numSplit[1];
        }
        else { num = value; }

        if (num.length > 1) {
          sign = num.substring(0, 1);
          if (sign !== "-" && sign !== "+") { sign = ""; }
          else { num = num.substring(1, num.length); }
        }

        num = num.replace(/[^0-9]/gi, "");
        if (decimal === undefined) { decimal = ""; }
        decimal = decimal.replace(/[^0-9]/gi, "");

        if (decimal !== "") { num = [num, decimal].join("."); }
        num = Number(sign + num);
        break;
      default:
        return defaultNum;
    }
    for (const key in defaultOptions) {
      if (defaultOptions.hasOwnProperty(key)) {
        switch (key) {
          case "toNumber_digits":
            let digits = defaultOptions[key];

            if (digits >= 0) { num = parseFloat(num.toFixed(digits)); }
            else {
              const fixdigits = Math.pow(10, Math.abs(digits));
              digits = Math.pow(10, digits);
              num = Number(Math.round(num * digits).toFixed(0)) * fixdigits;
            }
            break;
        }
      }
    }
    return num;
  }

  public toNumber(value: any, options?: object) {
    const defaultOptions = {
      toNumber_digits: undefined,
      toNumber_default: 0
    };
    for (const key in options) {
      if (options.hasOwnProperty(key)) { defaultOptions["toNumber_" + key] = options[key]; }
    }
    const defaultNum = defaultOptions.toNumber_default;
    if (value === undefined || value === "") { return defaultNum; }
    if (value.constructor !== String && value.constructor !== Number) { }

    let num;
    switch (value.constructor) {
      case Number:
        num = value;
        break;
      case String:
        let sign = "";
        let decimal = "";
        const numSplit = value.split(".");
        if (numSplit.length === 2) {
          num = numSplit[0];
          decimal = numSplit[1];
        }
        else { num = value; }

        if (num.length > 1) {
          sign = num.substring(0, 1);
          if (sign !== "-" && sign !== "+") { sign = ""; }
          else { num = num.substring(1, num.length); }
        }

        num = num.replace(/[^0-9]/gi, "");
        if (decimal === undefined) { decimal = ""; }
        decimal = decimal.replace(/[^0-9]/gi, "");

        if (decimal !== "") { num = [num, decimal].join("."); }
        num = Number(sign + num);
        break;
      default:
        return defaultNum;
    }

    for (const key in options) {
      if (options.hasOwnProperty(key)) {
        switch (key) {
          case "toNumber_digits":
            let digits = options[key];

            if (digits >= 0) { num = parseFloat(num.toFixed(digits)); }
            else {
              const fixdigits = Math.pow(10, Math.abs(digits));
              digits = Math.pow(10, digits);
              num = Number(Math.round(num * digits).toFixed(0)) * fixdigits;
            }
            break;
        }
      }
    }
    return num;
  }
}
